import script from "./detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./detail.vue?vue&type=script&setup=true&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=3063d93a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3063d93a"]])

export default __exports__